/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTrackingIdForProBolNumberResponse
 */
export interface GetTrackingIdForProBolNumberResponse {
    /**
     * 
     * @type {string}
     * @memberof GetTrackingIdForProBolNumberResponse
     */
    trId?: string;
}

/**
 * Check if a given object implements the GetTrackingIdForProBolNumberResponse interface.
 */
export function instanceOfGetTrackingIdForProBolNumberResponse(value: object): value is GetTrackingIdForProBolNumberResponse {
    return true;
}

export function GetTrackingIdForProBolNumberResponseFromJSON(json: any): GetTrackingIdForProBolNumberResponse {
    return GetTrackingIdForProBolNumberResponseFromJSONTyped(json, false);
}

export function GetTrackingIdForProBolNumberResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTrackingIdForProBolNumberResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'trId': json['trId'] == null ? undefined : json['trId'],
    };
}

  export function GetTrackingIdForProBolNumberResponseToJSON(json: any): GetTrackingIdForProBolNumberResponse {
      return GetTrackingIdForProBolNumberResponseToJSONTyped(json, false);
  }

  export function GetTrackingIdForProBolNumberResponseToJSONTyped(value?: GetTrackingIdForProBolNumberResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trId': value['trId'],
    };
}

